export const blockIconsTextformattingNoteAddNew = (
	<span className='material-symbols-outlined'>note_add</span>
);
